import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarMenu from './Sidebar';
import { AiOutlineSearch } from 'react-icons/ai';
import { CiSettings } from 'react-icons/ci';
import { IoMdNotificationsOutline, IoMdMenu } from 'react-icons/io';
import { FaRegCircleUser } from 'react-icons/fa6';

const Layout = () => {
  const [sidebarToggled, setSidebarToggled] = useState(true);

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <SidebarMenu toggled={sidebarToggled} onBackdropClick={() => setSidebarToggled(false)} />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden transition-all duration-300">
        {/* Top Header */}
        <div className="p-4 flex justify-between items-center bg-white border-b border-gray-200 shadow-sm">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setSidebarToggled(!sidebarToggled)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <IoMdMenu size={24} className="text-gray-700" />
            </button>
            <div className="relative w-64 lg:w-96">
              <input
                type="text"
                placeholder="Search ..."
                className="border rounded-lg w-full h-10 px-4 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <AiOutlineSearch 
                size={19} 
                color="grey" 
                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" 
              />
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="p-3 rounded-full bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors">
              <CiSettings size={19} color="grey" />
            </div>
            <div className="p-3 rounded-full bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors">
              <IoMdNotificationsOutline size={19} color="grey" />
            </div>
            <div className="p-3 rounded-full bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors">
              <FaRegCircleUser size={19} color="black" />
            </div>
          </div>
        </div>
        
        {/* Main Content Area */}
        <div className="relative min-h-0 min-w-0 flex-1 overflow-auto bg-background hide-scrollbar">
          <div className="min-h-full w-full min-w-0">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
